import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Layout from 'components/layout'

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Layout />
        </BrowserRouter>
    )
}

export default AppRouter
